import React from 'react';
import { hooks } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';
import { HelpbotLink } from '../HelpbotLink';
import { useOrdersDataState } from '../../../../context/OrdersDataStateProvider';
import OrdersUncapturedOrdersYesBotMessage from './OrdersUncapturedOrdersYesBotMessage';
import OrdersUncapturedOrdersNoBotMessage from './OrdersUncapturedOrdersNoBotMessage';
const DefaultUncapturedOrdersBotMessage = () => {
    const t = hooks.useTranslator();
    const link1 = React.createElement(HelpbotLink, { href: '/orders/to-capture' }, t('helpbot.questions.orders.haveUncapturedOrdersPart2Link1'));
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.questions.orders.haveUncapturedOrdersPart1')),
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.questions.orders.haveUncapturedOrdersPart2', { link1 }))));
};
const MessageYes = ({ number }) => {
    const t = hooks.useTranslator();
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.explanations.orders.uncapturedDynamicYes', { number })),
        React.createElement("br", null),
        React.createElement(OrdersUncapturedOrdersYesBotMessage, null)));
};
const MessageNo = () => {
    const t = hooks.useTranslator();
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.explanations.orders.uncapturedDynamicNo')),
        React.createElement("br", null),
        React.createElement(OrdersUncapturedOrdersNoBotMessage, null)));
};
const DynamicUncapturedOrdersBotMessage = () => {
    const { data: { nbUncapturedOrders } } = useOrdersDataState();
    if (nbUncapturedOrders.hasError)
        return React.createElement(DefaultUncapturedOrdersBotMessage, null);
    if (nbUncapturedOrders.value)
        return React.createElement(MessageYes, { number: nbUncapturedOrders.value });
    return React.createElement(MessageNo, null);
};
export default DynamicUncapturedOrdersBotMessage;
